import { usePathname } from 'next/navigation';

import { navigationSteps } from '@/constants/navigation';
import { NavigationStep } from '@/types/navigation';

interface PaginationInfo {
  currentIndex: number;
  currentStep: NavigationStep;
  nextStep?: NavigationStep;
  previousStep?: NavigationStep;
  totalSteps: number;
}

export const usePagination = (): PaginationInfo => {
  const currentPath = usePathname();

  const index = navigationSteps.findIndex((route) => {
    if (route.isDynamic) {
      const basePath = route.path().split('/')[1];
      return currentPath.startsWith(`/${basePath}`);
    }
    return route.path() === currentPath;
  });

  return {
    currentIndex: index + 1,
    currentStep: navigationSteps[index],
    nextStep: navigationSteps[index + 1],
    previousStep: navigationSteps[index - 1],
    totalSteps: navigationSteps.length,
  };
};
